export const dashboardMenu = [
  {
    text: 'Artists',
    link: '/dashboard/artists/',
  },
  {
    text: 'Galleries',
    link: '/dashboard/galleries/',
  },
  {
    text: 'Stats',
    link: '/dashboard/stats/',
  },
  {
    text: 'Orders',
    link: '/dashboard/orders/',
  },
  {
    text: 'Users',
    link: '/dashboard/user/',
  },
  {
    text: 'Applications',
    link: '/dashboard/applications/',
  },
  {
    text: 'Accounting',
    link: '/dashboard/transactions/',
  },
  {
    text: 'Art of the day',
    link: '/dashboard/aotd/',
  },
  {
    text: 'Artist of the day',
    link: '/dashboard/artist-otd/',
  },
  {
    text: 'Artist homepage promos',
    link: '/dashboard/promotions/artist-hpp/',
  },
  {
    text: 'Marketing',
    link: '/dashboard/marketing/campaigns/',
  },
  {
    text: 'Problems',
    link: '/dashboard/problems/',
  },
  {
    text: 'Flags',
    link: '/dashboard/flags/',
  },
];
